import "@main/index.css";
import "@main/textScale.css";
import "@main/i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { initMsal, restoreEntraSession } from "@main/auth/msalConfig";
import { ThemeProvider } from "@main/context/ThemeContext";
import { BrandingProvider } from "@main/context/BrandingContext";
import { JsyApp } from "./JsyApp";

// The Jersey edition is Abacas-branded on its own host: no white-label lookup,
// so MSAL starts on the platform's Entra app registration. The redirect URI is
// window.location.origin (msalConfig.ts), i.e. https://jsy.abacassecurity.com,
// which must be registered as an SPA redirect URI on that app registration.
(async () => {
  const msalInstance = initMsal(import.meta.env.VITE_ENTRA_CLIENT_ID, import.meta.env.VITE_ENTRA_AUTHORITY);
  await msalInstance.initialize();
  await restoreEntraSession(msalInstance, import.meta.env.VITE_ENTRA_CLIENT_ID);

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrandingProvider initialBranding={null}>
        <ThemeProvider palette="wing">
          <MsalProvider instance={msalInstance}>
            <BrowserRouter>
              <JsyApp />
            </BrowserRouter>
          </MsalProvider>
        </ThemeProvider>
      </BrandingProvider>
    </React.StrictMode>
  );
})();
